import React from 'react';
import { Link } from 'react-router-dom';
import DiarySection from '../components/sections/DiarySection';
import './PageLayout.css';

const DiaryPage = () => {
  return (
    <div className="page-layout">
      <Link to="/" className="back-button">← Home</Link>
      <div className="page-content">
        <DiarySection />
      </div>
    </div>
  );
};

export default DiaryPage;

